module.exports = __webpack_public_path__ + "static/media/PollHistoryIcon.c8d15bf2.png";